import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import { ARTICLE_ID, TOP_ONE_EXTERNAL_URL } from '@src/constants/articles';
import ComponentStore from './store';
const styles = require('./index.less');

// 受控静态壳：主页入口按钮的外链/内页导航由链接语义与页面（MainStore）注入回调共同承接，
// 组件自身不持有路由副作用（controlled-static-shell-boundary）
const Home = ({ store, className, onNavToList }) => {
  store.use();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.group1} data-name={'首页'}>
        <div className={styles.layer1} data-name={'首页 - 背景'} />
        <div className={styles.group2} data-name={'首页内容'}>
          <div className={styles.group3} data-name={'按钮组wrapper'}>
            <div className={styles.group4} data-name={'按钮组 - list'}>
              <Link className={styles.layer2} data-name={'天下第一  帮会巅峰  '} href={TOP_ONE_EXTERNAL_URL} target="_blank" rel="noopener" />
              <Link className={styles.layer3} data-name={'福利狂欢  金币66600'} onClick={() => onNavToList(ARTICLE_ID.WELFARE_CARNIVAL)} />
              <Link className={styles.layer4} data-name={'预约新服  百万绑金'} onClick={() => onNavToList(ARTICLE_ID.RESERVE_SERVER)} />
              <Link className={styles.layer5} data-name={'减负调优  轻松武侠'} onClick={() => onNavToList(ARTICLE_ID.BURDEN_OPTIMIZATION)} />
              <Link className={styles.layer6} data-name={'战域领土  荣耀嘉奖 '} onClick={() => onNavToList(ARTICLE_ID.BATTLE_TERRITORY)} />
            </div>
          </div>
          <Link className={styles.layer7} data-name={'logo '} href={'https://jxsj.xoyo.com/index/index.html'} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(Home, ComponentStore);
